// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"957":"css/admin-app.6934","3492":"css/app.6934"}[chunkId] + ".css";
};